var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSeatbelts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.75 6.25a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M8.5 2a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5m7.25 6.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M17 6a2.75 2.75 0 1 0 0 5.5A2.75 2.75 0 0 0 17 6M5.286 12.26A5.8 5.8 0 0 1 7 12h3a5.75 5.75 0 0 1 5.412 3.804c1.688 1.728 3.934 3.055 5.838 3.815V17.75A3.25 3.25 0 0 0 18 14.5h-2a.75.75 0 0 1 0-1.5h2a4.75 4.75 0 0 1 4.75 4.75v2.371q.334.088.631.14a.75.75 0 1 1-.262 1.477c-1.98-.352-4.932-1.65-7.369-3.61v1.937q.292.138.543.245a.75.75 0 0 1-.586 1.38c-2.215-.939-6.663-3.57-10.778-7.652A4.25 4.25 0 0 0 2.75 17.75V21a.75.75 0 0 1-1.5 0v-3.25a5.75 5.75 0 0 1 2.609-4.817 34.3 34.3 0 0 1-3.74-4.777.75.75 0 0 1 1.262-.812 33 33 0 0 0 3.905 4.916m1.266 1.263c2.748 2.617 5.59 4.565 7.698 5.757v-1.53A4.25 4.25 0 0 0 10 13.5H7a4 4 0 0 0-.448.023",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgSeatbelts;